
import { defineComponent } from "vue";
import LandingPageCirculoSection from "./LandingPageCirculoSection.vue";
import Login from "../landingpage/Login.vue";
import LoginFormCirculo from "./LoginFormCirculo.vue";

export default defineComponent({
  components: { LoginFormCirculo, Login, LandingPageCirculoSection },

  setup() {
    return {};
  }
});
